import { render, staticRenderFns } from "./emoji_token.vue?vue&type=template&id=188aa898&"
import script from "./emoji_token.vue?vue&type=script&lang=js&"
export * from "./emoji_token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports